import { ApiError } from '@helpers/api/http-api-error';

/**
 * Representa un error de la API
 */
export class ApiException extends Error {
  /**
   * Códigos de error que recibe la API
   */
  error: ApiError[];

  constructor(error: ApiError[]) {
    super('API_ERROR');
    this.error = error;
  }
}
